import React, {useState} from 'react';
import {Button, Col, Row, Space, Tabs} from "antd";
import {CheckOutlined, ReloadOutlined, TeamOutlined, UserSwitchOutlined} from '@ant-design/icons';
import UserList, {Type} from "../components/UserList";
import GroupList from "../components/GroupList";
import NewUserModal from "../components/NewUserModal";
import NewGroupModal from "../components/NewGroupModal";

const {TabPane} = Tabs;

interface Refresh {
    [key: number]: number;
}

const Operations = (refresh: Refresh, setRefresh: React.Dispatch<React.SetStateAction<Refresh>>, tabKey: string, isVisible: {
    group: boolean,
    user: boolean
}, setVisible: React.Dispatch<React.SetStateAction<{
    group: boolean,
    user: boolean
}>>) => {
    const [loading, setLoading] = useState(false);

    const keys = {
        "1": {
            enabled: true,
            title: 'Add new user',
            action: () => setVisible({
                group: false,
                user: true
            })
        },
        "2": {
            enabled: false,
            title: null,
            action: undefined
        },
        "3": {
            enabled: true,
            title: 'Add a manufacturer group',
            action: () => setVisible({
                group: true,
                user: false
            })
        }
    }
    return (
        <Space style={{marginLeft: "1.2em"}}>
            {keys[tabKey as keyof typeof keys].enabled && <Button onClick={keys[tabKey as keyof typeof keys].action}>
                {keys[tabKey as keyof typeof keys].title}
            </Button>}
            <Button disabled={loading} icon={<ReloadOutlined spin={loading}/>} onClick={() => {
                setLoading(true)
                setTimeout(() => {
                    setLoading(false)
                }, 1000)
                setRefresh({...refresh, [tabKey]: refresh[parseInt(tabKey)] + 1})
            }}/>
        </Space>)
}

const AdminDashboard: React.FC = () => {
    const [tabIndex, setTabIndex] = useState("1")
    const [isVisible, setVisible] = useState({
        group: false,
        user: false
    })
    const [refresh, setRefresh] = useState<Refresh>({
        1: 0,
        2: 0,
        3: 0
    })

    const tabs = [
        {
            icon: <TeamOutlined/>,
            title: 'Users',
            component: <UserList refresh={refresh["1"]} type={Type.CONFIRMED}/>
        },
        {
            icon: <CheckOutlined/>,
            title: 'Waiting for approval',
            component: <UserList refresh={refresh["2"]} type={Type.UNCONFIRMED}/>
        },
        {
            icon: <UserSwitchOutlined/>,
            title: 'Groups',
            component: <GroupList refresh={refresh["3"]} />
        }
    ]

    return (
        <Row>
            <Col span={24}>
                <NewUserModal setRefresh={setRefresh} refresh={refresh} isVisible={isVisible} setVisible={setVisible}/>
                <NewGroupModal setRefresh={setRefresh} refresh={refresh} isVisible={isVisible} setVisible={setVisible}/>
                <Tabs onChange={setTabIndex} defaultActiveKey="1"
                      tabBarExtraContent={Operations(refresh, setRefresh, tabIndex, isVisible, setVisible)}>
                    {tabs.map((tab, key) => (
                        <TabPane
                            tab={
                                <span>
                                    {tab.icon}
                                    {tab.title}
                                </span>
                            }
                            key={key + 1}
                        >
                            {tab.component}
                        </TabPane>
                    ))}
                </Tabs>
            </Col>
        </Row>
    );
};

export default AdminDashboard;
